import React, { useEffect, useState } from "react";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { Checkbox, Spin } from "antd";
import { Page, Note } from "../../../helbest";
import { Phone } from "../../../base/env";
import { API } from "../../../request/api";
import { useParams } from "react-router-dom";

// points
import point_1 from "../../../assets/images/base/1.png";
import point_2 from "../../../assets/images/base/2.png";
import point_3 from "../../../assets/images/base/3.png";
import point_4 from "../../../assets/images/base/4.png";
import { LangLink } from "../../components/LangLink/LangLink";

const points = [
  {
    name: "Excellent",
    emoji: point_4,
    value: 4,
  },
  {
    name: "Good",
    emoji: point_3,
    value: 3,
  },
  {
    name: "Normal",
    emoji: point_2,
    value: 2,
  },
  {
    name: "Weak",
    emoji: point_1,
    value: 1,
  },
];

const Points = (props) => {
  const { id } = useParams();
  const [state, set_state] = useState({
    is_rated: false,
    checking_user_bill: true,
    point: 6,
    factor: {},
    selected: [],
    questions: {
      negative: [
        {
          value: 1,
          label: "عدم رعایت ادب و احترام مشتری",
        },
        {
          value: 2,
          label: "عدم ارائه خدمات و سرویس مناسب",
        },
        {
          value: 3,
          label: "اجبار به خرید اقلام اضافی",
        },
        {
          value: 4,
          label: "دریافت وجه اضافی",
        },
        {
          value: 5,
          label: "موارد دیگر",
        },
      ],
      positive: [
        {
          value: 1,
          label: "رعایت ادب و احترام مشتری",
        },
        {
          value: 2,
          label: "ارائه خدمات و سرویس مناسب",
        },
        {
          value: 3,
          label: "مشاوره خوب درباره اقلام خریداری شده",
        },
        {
          value: 4,
          label: "کمک در انتخاب اقلام مورد نیاز مشتری",
        },
        {
          value: 5,
          label: "موارد دیگر",
        },
      ],
    },
  });

  useEffect(() => {
    /* first check that user is rated our services or not with checking_user_bill_state
     * if user rated our service details of the factor are shown
     * if user not rated our service rating form is shown
     * TODO: integrate api for get real questions & update questions array with api data
     */
    API.get
      .userBill(id)
      .then((response) => {
        set_state({
          ...state,
          factor: response.data,
          is_rated: response.data.is_rated,
          checking_user_bill: false,
          // questions: response.data.poll_questions
        });
      })
      .catch((error) => {
        Note.error("Error in connecting to the server");
        console.log("Error : ", error);
      });
    // eslint-disable-next-line
  }, []);

  const onChange = (checkedValues) => {
    set_state({
      ...state,
      selected: checkedValues,
    });
  };

  const _save = () => {
    if (state.point === 6) {
      return Note.error("please register your satisfaction.");
    }

    if (state.selected.length === 0) {
      return Note.error("please select at least one question.");
    }

    API.post
      .rate(id, state.point, state.selected)
      .then((r) => {
        Note.success("Your feedback has been registered. Thanks");
        set_state({ ...state, is_rated: true });
      })
      .catch((e) => {
        Note.error("Error in connecting to the server");
      });
  };

  const onChangePoint = (e) => {
    set_state({
      ...state,
      selected: [],
      point: e.target.value,
    });
  };

  return (
    <Page
      className="page-profile"
      showFooter
      back={true}
      address="/factors/"
      customHeader={<HeaderBack title="Rating" />}
      mobileContainer
      headerFix
      logo
    >
      {state.checking_user_bill && <Spin className="points-spinner" />}
      {!state.checking_user_bill && !state.is_rated && (
        <div className="points-main animated fadeInUp">
          <p className="  mb-2">
            Submit your level of satisfaction with the autoservice
          </p>
          <div className="point-radio">
            {points.map((point, pointIndex) => {
              return (
                <label className="point-container" key={pointIndex}>
                  <input
                    type="radio"
                    name="point"
                    value={point.value}
                    onClick={onChangePoint}
                  />
                  <img className="point-img" src={point.emoji} alt="4" />
                  <p>{point.name}</p>
                </label>
              );
            })}
          </div>

          {state.point !== 6 && (
            <div className="rtl ques">
              <h5>The reasons for your dissatisfaction</h5>
              <Checkbox.Group
                options={
                  state.questions[state.point < 3 ? "negative" : "positive"]
                }
                onChange={onChange}
                value={state.selected}
              />
            </div>
          )}

          <div className="mt-3 flex-box">
            <button
              className="btn-h40 btn line-none font-14 px-5 w-120 submit-points-btn"
              onClick={_save}
            >
              Submit and Send
            </button>

            {state.point < 3 ? (
              <button
                href={Phone}
                className="btn-h40 page-points-call-us-btn line-none font-14 px-5 w-120 m-2"
              >
                <LangLink to="/contactus">Contact Us</LangLink>
              </button>
            ) : null}
          </div>
        </div>
      )}
      {!state.checking_user_bill && state.is_rated && (
        <div>
          <div className="points-main rtlo animated fadeInUp factor">
            <h4>{`Service Center ${state.factor.service_center_name}`}</h4>
            <p className="text-left ml-2">
              <strong>Time : </strong>
              {`${state.factor.time}`}
            </p>
            <p className="text-left ml-2">
              <strong>Date :</strong> <label>{state.factor.date}</label>
            </p>
            <p className="text-left ml-2">
              <strong>Current Kilometers : </strong>
              {state.factor.current_killometer}
            </p>

            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="width-400px">Product name or services</th>
                </tr>
              </thead>
              <tbody>
                {state.factor?.items?.map((x, i) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td className="width-400px">
                      {x.name}
                      <hr />
                      {x.suggest_usage_limit?.usage_limit_type === "km"
                        ? `Suggested kilometers : ${x.suggest_usage_limit?.usage_limit}`
                        : `(${x.suggest_usage_limit?.usage_limit})`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Page>
  );
};

export default Points;
